// TODO: Fix eslint errors.
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable radix */
import React, { useEffect } from 'react';
import { Helmet } from 'rnd-helmet';
import { injectIntl } from 'react-intl';
import HeaderText from '@UI/HeaderText';
import BlogFilter from '@Filters/Blog';
import SortBar from '@Components/SortBar';
import Pager from '@Components/Pager';
import NoResults from '@Components/NoResults';
import { useRouteMatch } from 'react-router-dom';
import { generateDataLayer } from 'dataLayerHelper';
import withSearch from '../../components/hoc/Search';

function SuccessStories({
  intl, searchParams, pager, articles, total, staticContext,
}) {
  const { locale } = intl;
  const route = useRouteMatch();
  if (staticContext && staticContext.data) {
    // Pass the dataLayer to the server using staticContext.
    if (staticContext.appConfigurations
      && staticContext.appConfigurations.hasOwnProperty('rbd_tracking.settings')
      && staticContext.appConfigurations['rbd_tracking.settings'].gtm
      && staticContext.appConfigurations['rbd_tracking.settings'].gtm.enabled) {
      staticContext.dataLayer = generateDataLayer('other_content', locale);
    }
  }

  useEffect(() => {
    if (process.env.REACT_APP_ENABLE_GTM === 'true') {
      window.dataLayer = window.dataLayer || [];
      // Push the dataLayer as new array item.
      window.dataLayer.push({
        event: 'view_item_list',
        ...generateDataLayer('other_content', locale),
      });
    }
  }, [locale]);

  let metaTitle = intl.formatMessage({ id: 'SuccessStories.Title' }, { sitename: process.env.REACT_APP_SITENAME });
  let metaDescription = intl.messages['SuccessStories.MetaDescription'] ? intl.messages['SuccessStories.MetaDescription'] : null;
  let titleTop = intl.formatMessage({ id: 'SuccessStoriesHeader.TitleTop' });
  let titleBottom = intl.messages['SuccessStoriesHeader.TitleBottom'] ? intl.formatMessage({ id: 'SuccessStoriesHeader.TitleBottom' }) : null;

  if (route.params.hasOwnProperty('categoryParam') && route.params.categoryParam !== undefined
    && searchParams.hasOwnProperty('categoryName') && searchParams.categoryName !== undefined) {
    metaTitle = intl.messages['SuccessStories.CategoryTitle'] ? intl.formatMessage({ id: 'SuccessStories.CategoryTitle' }, {
      sitename: process.env.REACT_APP_SITENAME,
      category: searchParams.categoryName,
    }) : metaTitle;
    metaDescription = intl.messages['SuccessStories.CategoryMetaDescriptionTitle'] ? intl.formatMessage({ id: 'SuccessStories.CategoryMetaDescriptionTitle' }, {
      sitename: process.env.REACT_APP_SITENAME,
      category: searchParams.categoryName,
    }) : metaDescription;
    titleTop = intl.messages['SuccessStoriesHeader.CategoryTitleTop'] ? intl.formatMessage({ id: 'SuccessStoriesHeader.CategoryTitleTop' }, { category: searchParams.categoryName }) : titleTop;
    titleBottom = intl.messages['SuccessStoriesHeader.CategoryTitleTopBottom'] ? intl.formatMessage({ id: 'SuccessStoriesHeader.CategoryTitleTopBottom' }) : titleBottom;
  }
  metaTitle = metaTitle.charAt(0).toUpperCase() + metaTitle.slice(1);
  return (
    <div id="articles-search-listing">
      <Helmet>
        <title>{metaTitle}</title>
        {metaDescription ? <meta name="description" content={metaDescription} /> : null}

        <link rel="stylesheet" media="all" href="/articles/static/assets/css/additional.css" />
        <link rel="canonical" href={`${process.env.REACT_APP_BASE_URL}${route.url}`} />
      </Helmet>
      <HeaderText
        variation="blue"
        titleTop={titleTop}
        titleBottom={titleBottom}
      >
        {intl.messages['SuccessStoriesHeader.text'] && intl.formatMessage({ id: 'SuccessStoriesHeader.text' })}
      </HeaderText>
      <SortBar resultsTotal={total} searchParams={searchParams} />
      <div className="block block--filter">
        <div className="block__wrapper wrapper">
          <BlogFilter pageType="blog" searchParams={searchParams} resultsTotal={total} />
          <div className="block__content block__content--s block__content--align-right">
            <div className="blog-overview blog-overview--list " data-rs-carousel-wrapper="">
              <ul className="blog-overview__list" data-rs-carousel="blog-overview--list">
                {total > 0 ? articles : <NoResults />}
              </ul>
            </div>
            <Pager previous={pager.previous} pagesList={pager.pages} next={pager.next} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(withSearch(SuccessStories));
